import {CheckBox} from '@prtimes-basis/check-box';
import {useController} from 'react-hook-form';
import {useMemo} from 'react';
import {useMasterData} from '../../../../../components/master-data-provider';
import styles from './categories-field.module.css';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function CategoriesField() {
  return (
    <FormField.Root name='companyInfo.companyCategoryIds'>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {control} = useFormField();
  const {
    field: {value, onChange, ref},
  } = useController({control, name: 'companyInfo.companyCategoryIds'});

  const onCheched = (id: string, checked: boolean) => {
    if (checked && !value.includes(id)) {
      onChange([...value, id]);
    }

    if (!checked && value.includes(id)) {
      onChange(value.filter((category) => category !== id));
    }
  };

  const masterData = useMasterData();
  const categories = useMemo(
    () =>
      masterData?.companyCategory.map((c) => ({
        id: c.id,
        label: c.name,
      })) ?? [],
    [masterData?.companyCategory],
  );

  return (
    <fieldset>
      <legend className={companyRegistrationPageStyles.srOnly}>
        企業カテゴリ
      </legend>

      <ul ref={ref} className={styles.categories}>
        {categories.map(({id, label}) => (
          <li key={id}>
            <CheckBox
              name='companyInfo.companyCategories'
              label={label}
              checked={value.includes(id)}
              aria-describedby='companyInfo.companyCategories-error'
              onChecked={(checked) => {
                onCheched(id, checked);
              }}
            />
          </li>
        ))}
      </ul>
    </fieldset>
  );
}
